export function useRating({ dispatch, value }) {
  const onChange = (value) => {
    dispatch({ type: 'RATING_CHANGE', payload: value });
  };

  return { value, onChange };
}
